import gql from 'graphql-tag';

export const SubnetFragment = gql`
  fragment Subnet on Subnet {
    id: uniqueId
    name
    availabilityZone: az
    cidr
    private
    delegated
    resourceGroup
    natGateway
    secondaryIpRanges {
      name
      cidr
    }
  }
`;

export const CloudVpcFragment = gql`
  fragment CloudVpc on CloudVpc {
    id: uniqueId
    name
    cidr
    frameManaged
    dnsServers
    resourceGroup
    subnets {
      ...Subnet
    }
  }
  ${SubnetFragment}
`;
